<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="mdi-account-search"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mx-1">
        <v-col cols="12">
          <v-row class="mx-1">
            <v-col cols="12">
              <v-row class="ml-n5">
                <v-col cols="8">
                  <v-col cols="5">
                    <v-text-field
                        dense
                        outlined
                        placeholder="Vị trí tuyển dụng"
                        v-model="career.name"
                        @input="debounceInput"
                    ></v-text-field>
                  </v-col>

                </v-col>
                <v-col class="text-right" cols="4">
                  <v-btn
                      color="primary"
                      @click="addCareer"
                  >
                    Thêm
                  </v-btn>
                </v-col>

              </v-row>
            </v-col>
          </v-row>
          <v-row align="center" class="mt-n6" justify="center">
            <v-col cols="12">
              <v-data-table
                  :headers="headers"
                  :items="searchCareer"
                  :items-per-page="10"
                  class="elevation-1"
              >
                <template v-slot:item.position_carrers="{ item }">
                  <span v-for="(name,index) in item.position_carrers" :key="index">
                    {{ name.name }}<span v-if="index != (item.position_carrers.length - 1)">,</span>
                  </span>
                </template>
                <template v-slot:item.created_at="{ item }">
                  {{formatDateTime(item.created_at)}}
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon class="mr-2" small @click="editItem(item.id)">
                    mdi-pencil
                  </v-icon>
                  <v-icon small @click="deleteItem(item.id)"> mdi-delete</v-icon>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {DELETE_CAREER,SEARCH_CAREER} from "@/store/modules/career";
import {debounce} from "debounce";


export default {
  name: "Career",
  data() {
    return {
      page: "Danh sách Carrers",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách Carrers",
          disabled: false,
        },
      ],
      headers: [
        {
          text: 'STT',
          align: 'start',
          value: 'id',
        },
        {text: 'Vị trí tuyển dụng', value: 'name'},
        {text: 'Kinh nghiệm', value: 'position_carrers'},
        {text: 'Lương', value: 'upto_salary'},
        {text: 'Thời gian', value: 'created_at'},
        {text: 'Actions', value: 'actions', sortable: false},
      ],
      career : [{
        name : ""
      }],
    }
  },
  computed: {
    ...mapGetters({
      searchCareer: "searchCareer",
    }),
  },
  async created() {
    await this.$store.dispatch(SEARCH_CAREER);
  },
  mounted() {

  },
  methods: {
    debounceInput: debounce(function (e) {
      this.career.name = e;
      let param = { name : this.career.name};
      console.log(param)
      this.$store.dispatch(SEARCH_CAREER, param);
    }, 200),
    formatDateTime(date) {
      if (!date) return null
      const newDate = new Date(date)
      const [year, month, day] = [newDate.getFullYear(), newDate.getMonth() + 1, newDate.getDate()]
      return `${day} / ${month} / ${year}`
    },
    addCareer() {
      this.$router.push('/career_management/career/add_career')
    },
    editItem(id) {
      this.$router.push({
        path: "/career_management/career/edit_career/" + id,
      });
    },
    deleteItem(id) {
      confirm('Bạn có chắc chắn muốn xóa không ?') &&
      this.$store.dispatch(`${DELETE_CAREER}`, id).then(data => {
        if (data && data.status === 1) {
          this.$store.dispatch(SEARCH_CAREER);
        }
      })
    },
  }
}
</script>

<style scoped>

</style>